const ERROR_PRESENTATIONS = {
  400: {
    title: "Invalid request",
    message: "The request could not be processed. Please review it and try again.",
    retryable: false,
  },
  401: {
    title: "Session expired",
    message: "Your session has expired. Please sign in again.",
    retryable: false,
  },
  403: {
    title: "Access denied",
    message: "You do not have permission to access this resource.",
    retryable: false,
  },
  404: {
    title: "Not found",
    message: "The requested resource could not be found.",
    retryable: false,
  },
  429: {
    title: "Too many requests",
    message: "The service is receiving too many requests. Please wait a moment and try again.",
    retryable: true,
  },
  500: {
    title: "Service error",
    message: "The service encountered an unexpected error. Please try again.",
    retryable: true,
  },
  502: {
    title: "Service unavailable",
    message: "The service is temporarily unavailable. Please try again shortly.",
    retryable: true,
  },
  503: {
    title: "Service unavailable",
    message: "The service is temporarily unavailable. Please try again shortly.",
    retryable: true,
  },
  504: {
    title: "Request timed out",
    message: "The service took too long to respond. Please try again.",
    retryable: true,
  },
};

export const getApiErrorPresentation = (error) => {
  const status = error?.response?.status || error?.status;

  if (status && ERROR_PRESENTATIONS[status]) {
    return { code: status, ...ERROR_PRESENTATIONS[status] };
  }

  if (status) {
    return {
      code: status,
      title: status >= 500 ? "Service error" : "Request failed",
      message: status >= 500
        ? "The service encountered an unexpected error. Please try again."
        : "The request could not be completed.",
      retryable: status >= 500,
    };
  }

  if (error?.request && !error?.response) {
    return {
      code: "Connection issue",
      title: "Unable to connect",
      message: "We could not connect to the service. Check your connection and try again.",
      retryable: true,
    };
  }

  return { code: 500, ...ERROR_PRESENTATIONS[500] };
};
